app.controller("AddActivationController", [
    "$scope", "StaticData", "$uibModalInstance", "Subject", "InfoModal", "toastr", "Selection",
    function ($scope, StaticData, $uibModalInstance, Subject, InfoModal, toastr, Selection) {
        $scope.chosenSubject = null;

        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.activate = function () {
            if (!$scope.chosenSubject || !$scope.chosenSubject._id) {
                return toastr.error('', 'საგანი არაა არჩეული.');
            }

            Selection.activateSubject({subjectId: $scope.chosenSubject._id}).then(function (resp) {
                if(resp.status === "success"){
                    toastr.success('',"საგანი წარმატებით გააქტიურდა");
                } else if (resp.status === "exists") {
                    toastr.warning('',"საგანი უკვე გააქტიურებულია");
                } else if (resp.status === "notInProgram") {
                    toastr.warning('',"საგანი არ ეკუთვნის არცერთ პროგრამას");
                } else {
                    toastr.error('',"დაფიქსირდა სერვერის შეცდომა");
                }
                $uibModalInstance.close();
            });
        };
    }
]);